export enum UserPermissionCodeEnum {
  //ADMIN AREA
  VIEW_ADMIN_AREA = 'VIEW_ADMIN_AREA',

  //USERS
  CREATE_USER = 'CREATE_USER',
  EDIT_USER = 'EDIT_USER',
  VIEW_USER = 'VIEW_USER',
  DELETE_USER = 'DELETE_USER',
  UNLOCK_USER = 'UNLOCK_USER',

  //SCENARIOS
  CREATE_SCENARIO = 'CREATE_SCENARIO',
  EDIT_SCENARIO = 'EDIT_SCENARIO',
  VIEW_SCENARIO = 'VIEW_SCENARIO',
  DELETE_SCENARIO = 'DELETE_SCENARIO',
  RUN_SCENARIO = 'RUN_SCENARIO',
}
